import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Lenspire_Icon_ArrowDropdownHeader",
  "use": "Lenspire_Icon_ArrowDropdownHeader-usage",
  "viewBox": "0 0 10 6",
  "content": "<symbol viewBox=\"0 0 10 6\" id=\"Lenspire_Icon_ArrowDropdownHeader\">\n<g>\n\t<path d=\"M5,6L0.293,1.597c-0.391-0.365-0.391-0.957,0-1.323c0.391-0.365,1.024-0.365,1.415,0L5,3.354l3.292-3.081\n\t\tc0.391-0.365,1.023-0.365,1.414,0c0.391,0.366,0.391,0.958,0,1.323L5,6z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./frontend/assets/icons/Lenspire_Icon_ArrowDropdownHeader.svg
// module id = 495
// module chunks = 0